import { sequenceNumber } from "../../../revampCRUD/ticketsNforms.crud";

export const getInsertOptions = async () => {
	const insertOptions = [
		{ name: "Email", value: "${email_id}" },
		{ name: "Phone Number", value: "${phone_number}" },
		{ name: "Booking ID", value: "${booking_id}" },
		{ name: "Ticket Name", value: "${ticket_name}" },
		{ name: "Name", value: "${name}" },
		{ name: "Event URL", value: "${event_url}" },
		{ name: "Event Name", value: "${event_name}" },
		{ name: "Organiser Email", value: "${organiser_email}" },
		{ name: "Ticket URL", value: "${ticket_url}" },
		{ name: "QR Code", value: "${qr_code}" },
		{ name: "Referral link", value: "${referral_link}" },
		{ name: "Refund Amount", value: "${refund_amount}" },
	];
	try {
		const res = await sequenceNumber(eventDetails.event_id);
		if (res.status === 200) {
			const seqNumDetailsFromApi = res.data.sequence_number_details;
			const seqDataForApi = [];

			seqNumDetailsFromApi?.forEach((obj) => {
				const seqName = obj?.sequence_name?.toLowerCase().replace(" ", "_");
				placeHolderArr[obj?.sequence_name] = `{${seqName}}`;
				seqDataForApi.push({
					name: `{${seqName}}`,
					value: `{seq_${obj?.sequence_id.replaceAll("-", "_")}}`
				});
			});

			insertOptions.push({
				name: "Sequence Numbers",
				children: seqDataForApi,
			});
		}
	} catch (err) {
		const errorMessage = err?.response?.data?.error || "Something went wrong";
		customToast.error(errorMessage);
	}
	return insertOptions;
};

export const insertOptions = [
	{ name: "Email", value: "${email_id}" },
	{ name: "Phone Number", value: "${phone_number}" },
	{ name: "Booking ID", value: "${booking_id}" },
	{ name: "Ticket Name", value: "${ticket_name}" },
	{ name: "Name", value: "${name}" },
	{ name: "Event URL", value: "${event_url}" },
	{ name: "Event Name", value: "${event_name}" },
	{ name: "Organiser Email", value: "${organiser_email}" },
	{ name: "Ticket URL", value: "${ticket_url}" },
	{ name: "QR Code", value: "${qrcode}" },
	{ name: "Referral link", value: "${referral_link}" },
	{ name: "Refund Amount", value: "${refund_amount}" },
	{ name: "Booking Date", value: "${registered_at}" },
	{ name: "Organizer Name", value: "${organiser_name}" },
	{ name: "Event Date", value: "${event_date}" },
	{ name: "Venue", value: "${venue}" },
	{ name: "Venue URL", value: "${venue_url}" },
];

// "UTM Source": "utm_source",
// "UTM Campaign": "utm_campaign",
// "UTM Medium": "utm_medium",

// Designation: "designation",
// "Payment Id": "payment_id",
// "Time Stamp": "registered_at",
// "Paid Amount": "amount_paid",

// "Ticket Status": "ticket_status",
// Consent: "consent",
// "Ticket Type": "ticket_type",
// Country: "country",

// Organisation: "organisation",
// "Ticket Price": "ticket_price",
// "Whatsapp Consent": "whatsapp_consent",
// "Whatsapp Number": "whatsapp_number",

// "Discount Code": "country_code",

// "Event Venue": "event_venue",
// "Event City": "event_city",
// "Event State": "event_state",
// "Event Country": "event_country",

// "Event Start Date": "event_start_date",
// "Event End Date": "event_end_date",
// "Event Start Time": "event_start_time",
// "Event End Time": "event_end_time",
// "Event Website": "event_website",
// "Event Live Link": "event_live_link",
